<template>
  <div class>
    <div id="mainDiv" class="container roundedBorder secondary-bg primary-fg">
      <h2>
        Generate a strong
        <b class="secondary-fg">password</b>
      </h2>

      <div class="row">
        <div class="input-field col s12 primary-color">
          <h6>Password length: {{passwordLength}} characters</h6>
          <vue-slider v-model="passwordLength" :min="8" :max="64"></vue-slider>
        </div>
      </div>

      <div class="row">
        <div class="input-field col s12 primary-color">
          <label for="includeNumbers">
            <input type="checkbox" id="includeNumbers" checked="true"/>
            <span>Include numbers ( e.g. 123456 )</span>
          </label>
        </div>
      </div>

      <div class="row">
        <div class="input-field col s12 primary-color">
          <label for="includeSymbols">
            <input type="checkbox" id="includeSymbols" checked="true"/>
            <span>Include symbols ( e.g. @#$% )</span>
          </label>
        </div>
      </div>

      <div class="row">
        <div class="input-field col s12 primary-color">
          <label for="includeLowerCaseLetters">
            <input type="checkbox" id="includeLowerCaseLetters" checked="true"/>
            <span>Include lowercase characters</span>
          </label>
        </div>
      </div>

      <div class="row">
        <div class="input-field col s12 primary-color">
          <label for="includeUpperCaseLetters">
            <input type="checkbox" id="includeUpperCaseLetters" checked="true"/>
            <span>Include uppercase characters</span>
          </label>
        </div>
      </div>

      <div class="row" style="margin-top:3rem;">
        <div class="input-field col s12 primary-color">
          <a
            class="waves-effect waves-light btn primary-bg"
            v-on:click="generateClicked"
          >Generate</a>
        </div>
      </div>
      
      <div class="row">
        <div class="input-field col s12 primary-color">
          <blockquote>
            Generated password: 
            <p v-on:click="copyTextToClipboard(generatedPassword)" class="secondary-fg" style="width:100%; overflow:hidden">{{generatedPassword}}</p>
          </blockquote>
        </div>
      </div>



    </div>
  </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import M from 'materialize-css';

export default {
  name: "PasswordGenerator",
  components: {
    VueSlider,
  },
  data: function () {
    return {
      passwordLength: 12,
      generatedPassword: ''
    };
  },
  methods:{
    copyTextToClipboard: function(text){
      var selected = false;
      var el = document.createElement('textarea');
      el.value = text;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      if (document.getSelection().rangeCount > 0) {
        selected = document.getSelection().getRangeAt(0)
      }
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }

      M.toast(
        {
          html: 'Copied to the clipboard!',
          displayLength: 1000
        }
      )
    },
    generateClicked: function(){
      
      var lowerCaseChars = "abcdefghijklmnopqrstuvwxyz".split("");
      var upperCaseChars = "abcdefghijklmnopqrstuvwxyz".toUpperCase().split("");
      var numbers = "0123456789".split("");
      var symbols = "@#$%+-.,[]()!&/=?_-".split("");


      //Get options
      var passwordLength = this.passwordLength
      var includeNumbers = document.getElementById('includeNumbers').checked
      var includeSymbols = document.getElementById('includeSymbols').checked
      var includeLowerCase = document.getElementById('includeLowerCaseLetters').checked
      var includeUpperCase = document.getElementById('includeUpperCaseLetters').checked

      var masterCharsArray = [];
      masterCharsArray = includeNumbers ? masterCharsArray.concat(numbers) : masterCharsArray;
      masterCharsArray = includeSymbols ? masterCharsArray.concat(symbols) : masterCharsArray;
      masterCharsArray = includeLowerCase ? masterCharsArray.concat(lowerCaseChars) : masterCharsArray;
      masterCharsArray = includeUpperCase ? masterCharsArray.concat(upperCaseChars) : masterCharsArray;

      if (masterCharsArray.length == 0) {
          alert('Please select at least one option.')
          return;
      }

      var generatedPassword = "";
      for (var i = 0; i < passwordLength; i++) {
          generatedPassword += masterCharsArray[Math.floor(Math.random() * masterCharsArray.length)];
      }

      var conditionChecker = true;
      //Check if all the conditions are met
      if (includeNumbers) {
          //at least 1 number is included or not
          for (var index = 0; index < numbers.length; index++) {
              if (generatedPassword.includes(numbers[index])) {
                  break;
              } else if (index == numbers.length - 1) {
                  //This is last element and still no match the condition is not met
                  conditionChecker = false;
              }
          }
      }

      if (includeSymbols && conditionChecker) {
          //at least 1 number is included or not
          for (index = 0; index < symbols.length; index++) {
              if (generatedPassword.includes(symbols[index])) {
                  break;
              } else if (index == symbols.length - 1) {
                  //This is last element and still no match the condition is not met
                  conditionChecker = false;
              }
          }
      }


      if (includeLowerCase && conditionChecker) {
          //at least 1 number is included or not
          for (index = 0; index < lowerCaseChars.length; index++) {
              if (generatedPassword.includes(lowerCaseChars[index])) {
                  break;
              } else if (index == lowerCaseChars.length - 1) {
                  //This is last element and still no match the condition is not met
                  conditionChecker = false;
              }
          }
      }

      if (includeUpperCase && conditionChecker) {
          //at least 1 number is included or not
          for (index = 0; index < upperCaseChars.length; index++) {
              if (generatedPassword.includes(upperCaseChars[index])) {
                  break;
              } else if (index == upperCaseChars.length - 1) {
                  //This is last element and still no match the condition is not met
                  conditionChecker = false;
              }
          }
      }


      if (conditionChecker) {
          // All conditions are met
          // Edit the DOM
          this.generatedPassword = generatedPassword
      }
      else {
          //All conditions are not met call the generator again.
          this.generateClicked()
      }
    }
  },
  mounted: function(){
    // Initialize the materialize components
    // This also closes the navbar if open
    M.AutoInit();
  },
  metaInfo: {
    title: 'Password Generator',
    meta: [
      {name: 'description', content: 'Generate a strong password using LockerApp. You can specify the length of your passwords [12 - 256] and whether you want to include numbers, symbols, lowercase characters, and uppercase characters.'},
      {name: 'application-name', content: 'LockerApp'},
      {name: 'author', content: 'Emre Biçer'},
      {name: 'keywords', content: 'LockerApp, Locker App, Locker, App, Password Manager, Password, Safe, Application, Last Password, Locker, Notes, Note Application, Mobile Application, Web Application'}
    ]
  }
};
</script>
<style scoped>
#mainDiv {
  padding: 20px;
}
</style>